<div fxLayout>
  <main [ngClass.lt-md]="{ mobile: true }">
    <header>
      <div class="container">
        <app-feature-flag-tabs>
          <sbnb-page-header navTabs [parentPath]="'support-documentation'">
            <h2 class="block sbnbDesktop:hidden">Give Feedback</h2>
          </sbnb-page-header>
        </app-feature-flag-tabs>
        <a class="back-link" [routerLink]="['/support-documentation']">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.62573 8.99774H12.3757"
              stroke="#ED3C6A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M8.43823 11.8102L5.62573 8.99774L8.43823 6.18524"
              stroke="#ED3C6A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M9.00073 16.8727C13.35 16.8727 16.8757 13.347 16.8757 8.99774C16.8757 4.6485 13.35 1.12274 9.00073 1.12274C4.65149 1.12274 1.12573 4.6485 1.12573 8.99774C1.12573 13.347 4.65149 16.8727 9.00073 16.8727Z"
              stroke="#ED3C6A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <div>Support documentation</div>
        </a>
      </div>
    </header>

    <div class="container">
      <div fxLayout fxLayoutAlign="start center" fxLayout.lt-md="column">
        <div fxFlex>
          <h1>Let's talk</h1>
          <p>You can schedule a call with our specialists at your convenience.</p>
        </div>
        <div fxFlex>
          <img src="/assets/images/support-documentation/schedule-call-team.png" alt="Our team" />
        </div>
      </div>

      <div fxLayout fxLayoutGap="24px" fxLayout.lt-md="column" style="margin-bottom: 24px">
        <div class="schedule-call-box" fxFlex>
          <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.9051 20.3077C13.9247 20.3077 14.7512 21.1342 14.7512 22.1538C14.7512 23.1734 13.9247 24 12.9051 24H5.53396C4.51436 24 3.6878 23.1734 3.6878 22.1538C3.6878 21.1342 4.51436 20.3077 5.53396 20.3077H12.9051ZM9.21951 0C14.3113 0 18.439 4.13276 18.439 9.23077C18.439 14.3288 14.3113 18.4615 9.21951 18.4615C4.12772 18.4615 0 14.3288 0 9.23077C0 4.13276 4.12772 0 9.21951 0ZM9.21951 3.69231C6.16443 3.69231 3.6878 6.17196 3.6878 9.23077C3.6878 12.2896 6.16443 14.7692 9.21951 14.7692C12.2746 14.7692 14.7512 12.2896 14.7512 9.23077C14.7512 6.17196 12.2746 3.69231 9.21951 3.69231Z"
                fill="#ED3C6A" />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="18.6667" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <h2>New to {{ 'CORE.PRODUCT_NAME' | transloco }}?</h2>
          <p>
            Want to get the most out of {{ 'CORE.PRODUCT_NAME' | transloco }}? Watch our training videos and you'll be a
            pro in no time.
          </p>
          <sbnb-button label="Watch videos" (clicked)="openVideos()" [fullWidth]="true"></sbnb-button>
        </div>

        <div class="schedule-call-box" fxFlex>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18 8H19C20.0609 8 21.0783 8.42143 21.8284 9.17157C22.5786 9.92172 23 10.9391 23 12C23 13.0609 22.5786 14.0783 21.8284 14.8284C21.0783 15.5786 20.0609 16 19 16H18"
              stroke="#ED3C6A"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M2 8H18V17C18 18.0609 17.5786 19.0783 16.8284 19.8284C16.0783 20.5786 15.0609 21 14 21H6C4.93913 21 3.92172 20.5786 3.17157 19.8284C2.42143 19.0783 2 18.0609 2 17V8Z"
              stroke="#ED3C6A"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M6 1V4" stroke="#ED3C6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 1V4" stroke="#ED3C6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 1V4" stroke="#ED3C6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <h2>Office hours</h2>
          <p>Are you a {{ 'CORE.PRODUCT_NAME' | transloco }} fan and want to help make it even better?</p>
          <sbnb-button
            label="Book an office hour call"
            [fullWidth]="true"
            (clicked)="openOfficeHoursModal()"></sbnb-button>
        </div>
      </div>
    </div>
  </main>
</div>
